import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({
  title,
  description,
  canonical,
  ogImage = '/img/donna-d-affari-che-sale-su-un-taxi-scaled.jpg',
  ogType = 'website',
  noIndex = false,
}) => {
  const siteName = 'NCC Bro Driver';
  const fullTitle = `${title} | ${siteName}`;
  const BASE_URL = 'https://nccbrodriver.it';
  const fullImage = `${BASE_URL}${ogImage}`;

  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    name: 'NCC Bro Driver',
    description:
      'Un servizio pensato per ogni esigenza. Affidabilità, flessibilità e professionalità sono al centro della nostra offerta. Scopri cosa rende NCC BRO DRIVER la scelta ideale per i tuoi spostamenti.',
    url: 'https://nccbrodriver.it/',
    telephone: '+39 351 363 1080',
    address: {
      '@type': 'PostalAddress',
      addressLocality: 'Milano',
      addressCountry: 'IT',
    },
  };

  //const canonicalUrl = 'https://nccbrodriver.it';

  /*const paths = [
    { name: 'Home', href: '/' },
    { name: 'Servizi', href: '/servizi' },
    { name: 'Contatti', href: '/contatti' },
    { name: 'Login', href: '/login' },
    { name: 'Registrati', href: '/signup' },
    { name: 'Password Dimenticata', href: '/forgot-password' },
    { name: 'Dashboard', href: '/dashboard' },
    { name: 'Le mie prenotazioni', href: '/reservations' },
    { name: 'Logout', href: '/logout' },
    { name: 'Contatti', href: '/contatti' },
    { name: 'FAQ', href: '/404' },
    { name: 'Assistenza clienti', href: '/404' },
    { name: 'Tariffe', href: '/404' },
    { name: 'Cookie Policy', href: '/cookie-policy' },
    { name: 'Privacy policy', href: '/privacy-policy' },
    { name: 'Termini & Condizioni', href: '/404' },
  ];*/

  /*const seo = {
    title: paths.find(path => path.href === location.pathname)?.name || '',
    description:
      'Un servizio pensato per ogni esigenza. Affidabilità, flessibilità e professionalità sono al centro della nostra offerta. \
          Scopri cosa rende NCC BRO DRIVER la scelta ideale per i tuoi spostamenti.',
    image: `/img/LOGO-1.svg`,
    pathname: location.pathname,
    type: 'website',
    siteName: 'NCC Bro Driver',
    url: `${canonicalUrl}${location.pathname}`,
  };*/

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(structuredData)}</script>
      {/* Base */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      {noIndex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph (Facebook, WhatsApp, LinkedIn) */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={fullImage} />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:locale" content="it_IT" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullImage} />
      <meta name="twitter:image:alt" content={title} />
    </Helmet>
  );
};

export default SEO;
